export default __webpack_public_path__ + "static/preloader-logo-js-4-4d62855ff4330cc5577eaf0076614b29.svg";